import members from './members.json';
import member from './member.json';
import installationList from './installationList.json';
import installationRow from './installationRow.json';
import installationCreate from './installationCreate.json';
import installationEdit from './installationEdit.json';
import installationInfo from './installationInfo.json';
import installationComponents from './installationComponents.json';
import installationScenarios from './installationScenarios.json';
import installationAlerts from './installationAlerts.json';
import installationRooms from './installationRooms.json';
import componentEditHub from './componentEditHub.json';
import componentEditLink from './componentEditLink.json';
import componentEditExtension from './componentEditExtension.json';
import componentEditReader from './componentEditReader.json';
import componentEditScenario from './componentEditScenario.json';
import componentEditAjax from './componentEditAjax.json';
import componentEditSpc from './componentEditSpc.json';
import componentEditVideo from './componentEditVideo.json';
import componentEditVideoDevice from './componentEditVideoDevice.json';
import componentEditSmartIntego from './componentEditSmartIntego.json';
import componentEditUz from './componentEditUz.json';
import componentEditAperio from './componentEditAperio.json';
import adminCreation from './adminCreation.json';
import adminCreationSuccess from './adminCreationSuccess.json';
import interventions from './interventions.json';
import installerValidation from './installerValidation.json';
import accountActivationSuccess from './accountActivationSuccess.json';
import accountDeletionSuccess from './accountDeletionSuccess.json';
import accountDeletionCanceled from './accountDeletionCanceled.json';
import linkExpired from './linkExpired.json';
import appSetup from './appSetup.json';
import appUser from './appUser.json';
import acceptInvitation from './acceptInvitation.json';

export default {
  members,
  member,
  installationList,
  installationRow,
  installationCreate,
  installationEdit,
  installationInfo,
  installationComponents,
  installationScenarios,
  installationAlerts,
  installationRooms,
  componentEditHub,
  componentEditLink,
  componentEditExtension,
  componentEditReader,
  componentEditScenario,
  componentEditAjax,
  componentEditSpc,
  componentEditVideo,
  componentEditVideoDevice,
  componentEditSmartIntego,
  componentEditUz,
  componentEditAperio,
  adminCreation,
  adminCreationSuccess,
  interventions,
  installerValidation,
  accountActivationSuccess,
  accountDeletionSuccess,
  accountDeletionCanceled,
  linkExpired,
  appSetup,
  appUser,
  acceptInvitation,
};
